// UMass Amherst's undergraduate majors. Read on 2026-10-01 from the official
// list of degree programs that University Analytics and Institutional Research
// publishes ("Degree Programs Offered", FS_de_04.pdf, dated 7/23/2026), which
// lists every program by department within its school or college with the
// degree levels it awards: every bachelor's line kept; the Stockbridge School
// of Agriculture's associate degrees (A.S.), master's and doctoral programs
// left out. Where a program awards both a B.A. and a B.S. (or a B.A. and a
// B.F.A. or B.Mu), it is one line with both degrees. Degree abbreviations are
// the list's own. Program names are the list's degree-program lines (for
// example "Art History" under History of Art and Architecture). The flags and
// group notes quote the admissions office's Special Requirements for Selective
// Majors page (the college file's `specialMajors` source). The KB's majors
// list was the starting point; the official list wins.
const majors = {
    "slug": "university-of-massachusetts-amherst",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program on UMass Amherst's official list of degree programs, grouped by the school or college that offers it, with the degree it leads to. Associate degrees, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Humanities and Fine Arts",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "majors": [
                {
                    "name": "Afro-American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Architecture",
                    "degree": "B.S.",
                    "flag": "Portfolio sent directly to the department.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Art",
                    "degree": "B.A.",
                    "flag": "Portfolio sent directly to the department.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Art & Design",
                    "degree": "B.F.A.",
                    "flag": "Portfolio sent directly to the department.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Chinese Language and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Classics and Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Computational Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A., B.F.A.",
                    "flag": "Audition arranged with the Department of Music and Dance.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Film Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "German and Scandinavian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese Language and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Judaic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Chinese",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and German",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Portuguese",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A., B.Mu",
                    "flag": "Audition arranged with the Department of Music and Dance.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Portuguese",
                    "degree": "B.A."
                },
                {
                    "name": "Russian, Eurasian and Polish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theater",
                    "degree": "B.A."
                },
                {
                    "name": "Women, Gender, Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Information and Computer Sciences",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "B.A., B.S.",
                    "flag": "Highly selective; strong math through pre-calculus gets priority.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Informatics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Natural Sciences",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "majors": [
                {
                    "name": "Animal Science",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Plant and Soil Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Building and Construction Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Earth Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Natural Resources Conservation",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Pre-Veterinary",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Science/Interdepartmental",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainable Food & Farming",
                    "degree": "B.S."
                },
                {
                    "name": "Veterinary Technology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Social and Behavioral Sciences",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental and Natural Resource Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "B.S."
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Managerial Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Social Thought and Political Economy",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sustainable Community Development",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "majors": [
                {
                    "name": "Education",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "note": "First-year students are admitted to the college and choose a specific engineering major at the end of the first year.",
            "noteSource": "specialMajors",
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Isenberg School of Management",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "note": "Admission to the BBA program is selective; admitted first-year students enter it undeclared and are encouraged to declare a major before junior year.",
            "noteSource": "specialMajors",
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Operations & Information Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Sport Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.",
                    "flag": "Highly selective and open only to first-year applicants.",
                    "flagSource": "specialMajors"
                }
            ]
        },
        {
            "name": "School of Public Health and Health Sciences",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "majors": [
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Other degree programs",
            "source": {
                "label": "UMass Amherst UAIR, Degree Programs Offered (July 23, 2026)",
                "url": "https://www.umass.edu/uair/media/943/download"
            },
            "majors": [
                {
                    "name": "Bachelor's Degree with Individual Concentration (BDIC)",
                    "degree": "B.A., B.S.",
                    "flag": "Upper-division and self-designed; not open to entering students.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A., B.S."
                }
            ]
        }
    ]
};

export default majors;
